export enum ApiResponseStatus {
    INITIAL,
    LOADING,
    SUCCEEDED,
    FAILED,
}
